import { ChangeDetectionStrategy, Input, Component, HostBinding } from '@angular/core';
import { PopoverConfig } from './popover.config';
import { isBs3 } from '../utils/ng2-bootstrap-config';
var PopoverContainerComponent = (function () {
    function PopoverContainerComponent(config) {
        this.show = '!isBs3';
        this.role = 'tooltip';
        this.class = '"popover-fadeIn popover in popover-" + placement + " " + placement';
        Object.assign(this, config);
    }
    Object.defineProperty(PopoverContainerComponent.prototype, "isBs3", {
        get: function () {
            return isBs3();
        },
        enumerable: true,
        configurable: true
    });
    return PopoverContainerComponent;
}());
export { PopoverContainerComponent };
PopoverContainerComponent.decorators = [
    { type: Component, args: [{
                selector: 'mdb-popover-container',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: "\n  <div class=\"popover-arrow arrow\"></div>\n  <h3 class=\"popover-header\" *ngIf=\"title\">{{title}}</h3>\n  <div class=\"popover-body\">\n    <ng-content></ng-content>\n  </div>"
            },] },
];
/** @nocollapse */
PopoverContainerComponent.ctorParameters = function () { return [
    { type: PopoverConfig, },
]; };
PopoverContainerComponent.propDecorators = {
    'show': [{ type: HostBinding, args: ['class.show',] },],
    'role': [{ type: HostBinding, args: ['attr.role',] },],
    'class': [{ type: HostBinding, args: ['class',] },],
    'placement': [{ type: Input },],
    'title': [{ type: Input },],
};
//# sourceMappingURL=popover-container.component.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/popover/popover-container.component.js
// module id = ../../../../angular-bootstrap-md/popover/popover-container.component.js
// module chunks = 3